import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var ChevronUpIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M.47 10.53a.75.75 0 0 0 1.06 0L8 4.06l6.47 6.47a.75.75 0 1 0 1.06-1.06l-7-7a.75.75 0 0 0-1.06 0l-7 7a.75.75 0 0 0 0 1.06Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.53 18.53a.75.75 0 0 1-1.06 0L12 8.06 1.53 18.53a.75.75 0 0 1-1.06-1.06l11-11a.75.75 0 0 1 1.06 0l11 11a.75.75 0 0 1 0 1.06Z",
            clipRule: "evenodd"
        })
    }));
};
